import { render, staticRenderFns } from "./CustomerStepFormComponent.vue?vue&type=template&id=2bc98988&scoped=true"
import script from "./CustomerStepFormComponent.vue?vue&type=script&lang=js"
export * from "./CustomerStepFormComponent.vue?vue&type=script&lang=js"
import style0 from "./CustomerStepFormComponent.vue?vue&type=style&index=0&id=2bc98988&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bc98988",
  null
  
)

export default component.exports